document.addEventListener('click', function(e) {
  const btn = e.target.closest('a, button');
  if (btn && btn.getAttribute('href') === '#popup') {
    e.preventDefault();
    localStorage.removeItem('pebbletheme:popup');
    const popup = document.querySelector('subscribe-popup-component');
    if (popup) {
      const dialog = popup.querySelector('dialog');
      if (dialog) dialog.showModal();
    }
  }
});
